import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {CreateGoalContainerState} from '../state';
import {Display, Layout, Panel} from 'components';
import {GoalForm} from 'performance_goals/components';

const CreateGoalContainer = observer(({uiState}) => {
  const {backPath, title, goal, sharedWith, errors} = uiState;

  return (
    <div>
      <Display title={title} backPath={backPath} />
      <Layout>
        <Layout.Section secondary>
          <Panel>
            <GoalForm
              uiState={uiState}
              sharedWith={sharedWith}
              goal={goal}
              errors={errors}
              onSave={() => uiState.save()}
              onCancel={() => uiState.cancel()}
            />
          </Panel>
        </Layout.Section>
      </Layout>
    </div>
  );
});

export default withState(CreateGoalContainer, CreateGoalContainerState);
